import * as React from "react";
import WishlistLoader from "../../../../../../components/components/WishlistLoader.js";
import { useWishlistAuthState } from "../../../../../../hooks/hooks/use-wishlist-auth-state.js";
import AnonymousWishlistMenuItem from "./AnonymousWishlistMenuItem.js";
import UserWishlistMenuItem from "./UserWishlistMenuItem.js";
/* empty css                               */
const WishlistMenuItemContainer = (props) => {
  const { isAuthLoading, isUserLoggedIn } = useWishlistAuthState();
  const tealiumAttributesWishlist = {
    "data-element-id": `MainNav_Fav`
  };
  if (isAuthLoading) {
    return /* @__PURE__ */ React.createElement(WishlistLoader, null);
  }
  return !isAuthLoading && isUserLoggedIn ? /* @__PURE__ */ React.createElement(UserWishlistMenuItem, { ...props, tealiumAttributes: tealiumAttributesWishlist }) : /* @__PURE__ */ React.createElement(AnonymousWishlistMenuItem, { ...props, tealiumAttributes: tealiumAttributesWishlist });
};
export {
  WishlistMenuItemContainer as default
};
//# sourceMappingURL=WishlistMenuItemContainer.js.map
